module.exports = __webpack_public_path__ + "img/message-contarct.b808ce06.png";